import React from 'react'
import Header from '../Component/Header';
import MostWatched from '../Component/MostWatched';
import Favourite from '../Component/Favourite';
import Nav from '../Component/Nav';
import Footer from '../Component/Footer';
import Allmoves from '../Component/Allmoves';
import Loader from './Loader';


const Home = () => {
  return (
    <div>
    
        <Header/>
<div id='slider'>
  <div id='nav-wrapper'>
  <Nav/>
  </div>
 
        <div id='image-wrapper'>
<img src='/asset/marvel-intro.gif'/>
</div>
     </div>
     <Allmoves/>
     <MostWatched/>
     <Favourite/>
     <Footer/>
    </div>
  )
}

export default Home